import React from 'react';
import EquipmentManagementRouter from './EquipmentManagementRouter';

export default function EquipmentManagementPage() {
  return <EquipmentManagementRouter />;
}